export default {
  itens: [],
  item: [],
  news: 0,
  dialog: false
  // enviar: []
};
